import { api } from "../axios";
import { baseApiURL, healthyCheckApi } from "../endpoints";
import {
  setLoadingMessage,
  removeLoadingMessage,
} from "../../utils/setLoadingMessage";
import useBotControlStore from "../../storeModules/useBotControlStore";
import useInitialConfigStore from "../../storeModules/useInitialConfigStore";
import { tagInicio } from "../../utils/sendTag";
import sleepAwait from "../../utils/sleepAwait";
import findStep from "../../screens/bot/stepModules/findStep";

const fakeLoad = useInitialConfigStore.getState().fakeLoad;

const getApiHealthCheck = async () => {
  const url = `${baseApiURL}${healthyCheckApi}`;

  setLoadingMessage();

  api
    .get(url)
    .then(async (response) => {
      tagInicio();

      await sleepAwait(fakeLoad);

      if (response) {
        useBotControlStore.setState({
          currentStep: findStep("carrega_categorias").index,
        });
      } else {
        useBotControlStore.setState({
          currentStep: findStep("erro_geral").index,
        });
      }
    })
    .catch(() => {
      useBotControlStore.setState({
        currentStep: findStep("erro_geral").index,
      });
    })
    .finally(() => {
      removeLoadingMessage();
    });
};

export { getApiHealthCheck };
